// extracted by mini-css-extract-plugin
export var videoHero = "_bn-4";
export var videoHeroImage = "_bn-5";
export var videoHeroOverlay = "_bn-6";
export var videoHeroSubtitle = "_bn-8";
export var videoHeroText = "_bn-7";
export var videoLauncher = "_bn-0";
export var videoLauncherIcon = "_bn-1";
export var videoLauncherSubtitle = "_bn-3";
export var videoLauncherTitle = "_bn-2";
export var videoPlayer = "_bn-a";
export var videoPlayerWrap = "_bn-9";